module.exports = __webpack_public_path__ + "5413e71e8a572bb8fd97dba549e92c85.svg";